

















































































































































































import {
  defineComponent,
  onMounted,
  PropType,
  Ref,
  ref,
  watch,
} from '@vue/composition-api'
import AProductReview from './AProductReview.vue'
import ACustomerReviewForm from '../ACustomerReviews/ACustomerReviewForm.vue'
import AStarRating from '@/components/AStarRating'
import AButton from '@/components/AButton'
import APagination from '@/components/APagination'
import * as productApi from '@/api/product'
import { Review } from '@/interfaces/Product'
import AProductReviewSummary from './AProductReviewSummary.vue'
import ADivider from '@/components/ADivider'
import AIcon from '@/components/AIcon'
import { mdiLoading } from '@mdi/js'

export default defineComponent({
  name: 'AProductReviews',

  components: {
    AProductReview,
    ACustomerReviewForm,
    AStarRating,
    AButton,
    APagination,
    AProductReviewSummary,
    ADivider,
    AIcon,
  },

  props: {
    productId: {
      type: Number,
      required: true,
    },
    productTitle: {
      type: String,
      required: true,
    },
    productImage: {
      type: String,
    },
    reviewCount: {
      type: Number,
      required: true,
    },
    averageRating: {
      type: Number,
      required: true,
    },
    reviews: {
      type: Array as PropType<Review[]>,
      default: () => [],
    },
    loggedIn: {
      type: Boolean,
      required: true,
    },
    customerName: {
      type: String,
    },
    loginUrl: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const loadResults = ref(false)
    const watcher = ref<HTMLElement | undefined>()
    const loading = ref(false)
    const currentPage = ref(1)
    const pages = ref(0)
    const ratingFilter = ref(0)
    const modalShow = ref(false)
    const hasReviewed = ref(false)
    const postError = ref(false)
    const postSuccess = ref(false)
    const msgClass = ref('')
    const image = ref({})

    const responseData: Ref<undefined | productApi.GetReviewsResponse> =
      ref(undefined)

    async function fetchReviews() {
      if (!props.productId) {
        return
      }
      loading.value = true

      const res = await productApi.getReviews({
        productId: props.productId,
        page: currentPage.value,
        ratingFilter: ratingFilter.value,
      })

      console.log(res)
      responseData.value = res.data
      loading.value = false
    }

     async function alreadyReviewed() {
      const res = await productApi.hasReviewed(props.productId)
      console.log(res)
      hasReviewed.value = res.data >= 1 ? true : false;
      if (postSuccess.value) hasReviewed.value = true
    }

    onMounted (() => {
      if (watcher.value) {
        const el = watcher.value;
        document.addEventListener('scroll', function () {
          if (loadResults.value === false) {
            loadResults.value = isInViewport(el);
          }
        },{
          passive: true
        })
        setTimeout(
          async function() {
            if (loadResults.value === false) {
              if (props.productId && props.loggedIn) {
                await alreadyReviewed()
              }
              await fetchReviews()
            }
          }, 8000);
      }
    })

    function isInViewport(el: null|HTMLElement) {
      if (el) {
        const rect = el.getBoundingClientRect();
        return (rect.top >= 0);
      }
      return false;
    }

    function votedHandler(review: Review, upvotes: number) {
      review.upvotes = upvotes
      review.hasVoted = !review.hasVoted
    }

    function openReviewForm() {
      modalShow.value = true
    }

    function closeReviewForm() {
      modalShow.value = false
    }

    function saveReview (data: Review) { return }

    function toggleMessage(status: number) {
      switch (true) {
        case (status === 200):
          postSuccess.value = true
          postError.value = false
          msgClass.value = 'success-box'
          hasReviewed.value = true
          break;
        case (status >= 400):
          hasReviewed.value = true
          postError.value = true
          msgClass.value = 'error-box'
          break;
        default:
          postSuccess.value = false
          postError.value = false
          msgClass.value = ''
          hasReviewed.value = false
          break;
      }
    }

    function scrollTop() {
      const element = document.querySelector('.a-product-reviews')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
    
    watch(loadResults, async () => {
      if (props.productId && props.loggedIn) {
        await alreadyReviewed()
      }
      await fetchReviews()
    })

    watch(currentPage, async () => {
      scrollTop()
      await fetchReviews()
    })

    watch(ratingFilter, async () => {
      scrollTop()
      currentPage.value = 1
      await fetchReviews()
    })

    function toggleRatingFilter(rating: number) {
      if (ratingFilter.value !== rating) {
        ratingFilter.value = rating
        return
      }
      ratingFilter.value = 0
    }

    return {
      modalShow,
      image,
      hasReviewed,
      postError,
      postSuccess,
      msgClass,
      loading,
      responseData,
      votedHandler,
      currentPage,
      pages,
      ratingFilter,
      mdiLoading,
      loadResults,
      watcher,
      toggleRatingFilter,
      openReviewForm,
      closeReviewForm,
      saveReview,
      toggleMessage,
    }
  },
})
